import { createContext, useMemo } from 'react';
import { Outlet } from 'react-router-dom';
import type { JSX, ReactNode } from 'react';

import { BusinessEventContextStatus } from './types/business-event-context.type';
import type {
  BusinessEventContextData,
  BusinessEventScope,
} from './types/business-event-context.type';

const BusinessEventContext = createContext<BusinessEventContextData | null>(
  null,
);

interface Props {
  readonly scope: BusinessEventScope;
  readonly children?: ReactNode;
}

const BusinessEventContextProvider = ({
  scope,
  children,
}: Readonly<Props>): JSX.Element => {
  const contextValue = useMemo<BusinessEventContextData>(
    () => ({
      status: BusinessEventContextStatus.Ready,
      scope,
    }),
    [scope],
  );

  return (
    <BusinessEventContext.Provider value={contextValue}>
      {children ?? <Outlet />}
    </BusinessEventContext.Provider>
  );
};

export { BusinessEventContext, BusinessEventContextProvider };
